// extracted by mini-css-extract-plugin
export default {"ticketCard":"TicketTypeCard_ticketCard__lMmVA","ticketTitle":"TicketTypeCard_ticketTitle__Ab4qi","ticketDescription":"TicketTypeCard_ticketDescription__d2Tfj"};